import { render, staticRenderFns } from "./read-and-copy-field.vue?vue&type=template&id=09ea4867&"
import script from "./read-and-copy-field.vue?vue&type=script&lang=js&"
export * from "./read-and-copy-field.vue?vue&type=script&lang=js&"
import style0 from "./read-and-copy-field.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports